import type { FC } from 'react';
import { useMemo } from 'react';

import { useIsMobile } from '../../../hooks';
import { DesktopBestOffers } from './DesktopBestOffers';
import { MobileBestOffers } from './MobileBestOffers';
import type { BestOffersProps } from './types';

export const BestOffers: FC<BestOffersProps> = ({ content }) => {
  const isMobile = useIsMobile();
  const areBestOffersValid = useMemo(() => content?.some((item) => item.children.length > 0), [content]);

  if (content?.length === 0 || !areBestOffersValid) {
    return null;
  }

  if (isMobile) {
    return <MobileBestOffers content={content} />;
  }

  return <DesktopBestOffers content={content} />;
};
